import getProduct from './getProduct';
import closeAllMenus from '../../core/INF-closeAllMenus';

const QuickView = () => {
  let init_count = 1;

  const getListName = (e) => {
    const collectionAttr = e.target.closest('[data-collection]');
    const listName = collectionAttr ? collectionAttr.getAttribute('data-collection') : '';
    return listName;
  };

  document.addEventListener('click', (e) => {
    // Find the closest ancestor that matches the selector
    const buttonElement = e.target.closest('[data-quick-view-button]');
    const cartEdit = e.target.closest('[data-cart-edit]');
    const previousVariantId = e.target.closest('[data-id]')?.dataset.id;
    const previousVariantQty = e.target.closest('.CartProduct')?.querySelector('.CartProduct__quantity>select').value;
    const productData = e.target
      .closest('.fs_product_image_container')
      ?.parentElement.querySelector('.fs_product_data_wrapper .fs_product_data')?.textContent;

    if (buttonElement) {
      e.preventDefault();
      e.stopPropagation();

      init_count++;

      // Use the closest button element to get attributes
      const product_url = buttonElement.getAttribute('href') || buttonElement.getAttribute('data-href');
      const listName = getListName(e);
      // provide support for opening quick view modal in the cart page
      getProduct(
        product_url,
        init_count,
        listName,
        cartEdit !== null,
        previousVariantId,
        previousVariantQty,
        productData,
      );
    }
  });

  // Handle external/split PDP's or other product links from inside of modals
  document.addEventListener('click', (e) => {
    if (e.target.matches('[data-quick-view-content] a:not([data-quickview-ignore])')) {
      init_count++;

      const link = e.target;

      if (
        !link.getAttribute('href') ||
        (link.getAttribute('href') && link.getAttribute('href').indexOf('/products/') === -1)
      ) {
        return;
      }

      e.preventDefault();

      const listName = getListName(e);

      getProduct(link.getAttribute('href'), init_count, listName);
    }
  });

  document.addEventListener('click', (e) => {
    if (e.target.closest('.QuickView__content .ProductInfo__add-to-cart')) {
      const addButton = document.querySelector('.ProductInfo__button');
      let productName = addButton.getAttribute('data-product-name');
      if (addButton.hasAttribute('data-product-name') && productName.includes('Gift')) {
        let inputContainers = document.querySelectorAll('.input-container');
        let hasValidationError = false;

        inputContainers.forEach((container) => {
          if (container.classList.contains('validation-error')) {
            hasValidationError = true;
          }
        });

        if (!hasValidationError) {
          // Close the menus only if no validation errors were found
          closeAllMenus();
        }
      } else {
        closeAllMenus();
      }
    }
  });
};

export { QuickView };
